var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { GET_COUNTRY_INNER_PAGE_REQUEST, GET_COUNTRY_INNER_PAGE_SUCCESS, GET_COUNTRY_INNER_PAGE_ERROR } from '../actions/getCountryInnerPage';
import { POPUP_INIT } from '../actions/openPreviewPopup';
var initialState = {
    isFetching: false,
    isError: false,
    isPopupInnerPage: false,
    data: []
};
export function countryInnerPageReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case GET_COUNTRY_INNER_PAGE_REQUEST:
            return __assign(__assign({}, state), { isFetching: true });
        case GET_COUNTRY_INNER_PAGE_SUCCESS:
            return __assign(__assign({}, state), { isFetching: false, data: action.payload.data });
        case GET_COUNTRY_INNER_PAGE_ERROR:
            return __assign(__assign({}, state), { isFetching: false, isError: true });
        case POPUP_INIT:
            return __assign(__assign({}, state), { isPopupInnerPage: action.payload });
        default:
            return state;
    }
}
;
//# sourceMappingURL=countryInnerPage.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { GET_COUNTRY_INNER_PAGE_REQUEST, GET_COUNTRY_INNER_PAGE_SUCCESS, GET_COUNTRY_INNER_PAGE_ERROR } from '../actions/getCountryInnerPage';
import { POPUP_INIT } from '../actions/openPreviewPopup';
var initialState = {
    isFetching: false,
    isError: false,
    isPopupInnerPage: false,
    data: []
};
export function countryInnerPageReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case GET_COUNTRY_INNER_PAGE_REQUEST:
            return __assign(__assign({}, state), { isFetching: true });
        case GET_COUNTRY_INNER_PAGE_SUCCESS:
            return __assign(__assign({}, state), { isFetching: false, data: action.payload.data });
        case GET_COUNTRY_INNER_PAGE_ERROR:
            return __assign(__assign({}, state), { isFetching: false, isError: true });
        case POPUP_INIT:
            return __assign(__assign({}, state), { isPopupInnerPage: action.payload });
        default:
            return state;
    }
}
;
//# sourceMappingURL=countryInnerPage.js.map